module.exports = __webpack_public_path__ + "static/media/ReportMinimo.df5b2781.svg";